import consumer from "./consumer"

function bootInterviewChatCable() {
  const el = document.getElementById("interview-cable")
  if (!el || !el.dataset.interviewToken) return

  consumer.subscriptions.create(
    { channel: "InterviewChatChannel", interview_token: el.dataset.interviewToken },
    {
      received(data) {
        document.dispatchEvent(new CustomEvent("interview-chat:message", { detail: data }))
      }
    }
  )
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootInterviewChatCable)
} else {
  bootInterviewChatCable()
}
